import { Box, Button, Chip, Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { appliesLabel, discountText, formatDate, STATUS_COLORS, STATUS_LABELS } from './coupons.utils';

const rowLabelSx = { fontSize: 13, fontWeight: 400, fontFamily: 'Inter-Medium, sans-serif', color: 'text.secondary' };
const rowValueSx = { fontSize: 13, fontWeight: 600, fontFamily: 'Inter-Medium, sans-serif', textAlign: 'right' };

function Row({ label, children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '16px',
        padding: '9px 0',
        borderBottom: '1px solid #e4e8f0',
      }}
    >
      <Box sx={rowLabelSx}>{label}</Box>
      <Box sx={rowValueSx}>{children}</Box>
    </Box>
  );
}

export default function CouponDetailDrawer({ open, coupon, onClose, onEdit }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 420, maxWidth: '94vw', display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid #e4e8f0',
          }}
        >
          <Box sx={{ fontSize: 16, fontWeight: 700, fontFamily: 'Inter-Bold, sans-serif' }}>
            {coupon?.code || 'Coupon Details'}
          </Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {coupon && (
          <Box sx={{ padding: '18px 20px', overflowY: 'auto', flex: 1 }}>
            <Row label="Description">{coupon.description || '—'}</Row>
            <Row label="Discount">{discountText(coupon)}</Row>
            <Row label="Applies to">{appliesLabel(coupon.appliesTo)}</Row>
            <Row label="Min loan amount">₹{coupon.minLoanAmount || 0}</Row>
            <Row label="Status">
              <Chip
                size="small"
                label={STATUS_LABELS[coupon.status] || coupon.status}
                sx={{
                  backgroundColor: STATUS_COLORS[coupon.status]?.bg,
                  color: STATUS_COLORS[coupon.status]?.color,
                  fontWeight: 600,
                  fontSize: 11,
                  height: 22,
                }}
              />
            </Row>
            <Row label="Usage">
              {coupon.usage
                ? `${coupon.usage.currentUses} / ${coupon.usage.maxTotalUses || '∞'} (${coupon.usage.uniqueUsers} unique users)`
                : `${coupon.currentUses ?? 0} / ${coupon.maxTotalUses || '∞'}`}
            </Row>
            <Row label="Per-user limit">{coupon.maxPerUser ?? 1}</Row>
            <Row label="Valid">
              {formatDate(coupon.validFrom)} → {formatDate(coupon.validUntil)}
            </Row>
            <Row label="Product IDs">{coupon.productIds?.length ? coupon.productIds.join(', ') : 'All'}</Row>
            <Row label="Channel">{coupon.channel || 'All'}</Row>
            <Row label="Audience">{coupon.userId ? `User ${coupon.userId}` : 'Public'}</Row>
            <Row label="Created by">{coupon.createdBy || '—'}</Row>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'flex-end',
            padding: '14px 20px',
            borderTop: '1px solid #e4e8f0',
          }}
        >
          <Button size="small" onClick={onClose} sx={{ textTransform: 'none', fontSize: 12.5 }}>
            Close
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onEdit(coupon)}
            sx={{ color: '#fff', textTransform: 'none', fontSize: 12.5 }}
          >
            Edit
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
